import {
  resolveDraftPreviewRequest,
  type DraftPreviewRequestInput,
} from "./draft-preview";
import {
  buildSiteConfigForLocation,
  resolveLocationByHostOrNull,
  resolveSiteConfigFromEnv,
  type RestaurantSiteConfig,
} from "./restaurant-platform";

export const siteConfig = resolveSiteConfigFromEnv();

export function resolveSiteConfigForPublicRequest(
  input: DraftPreviewRequestInput,
): RestaurantSiteConfig {
  const draftPreview = resolveDraftPreviewRequest(input);
  if (draftPreview.kind === "resolved") {
    return buildSiteConfigForLocation(draftPreview.location, {
      env: input.env,
      draftPreview: true,
    });
  }

  const hostLocation = resolveLocationByHostOrNull(input.host ?? undefined);
  if (hostLocation) {
    return buildSiteConfigForLocation(hostLocation, {
      env: input.env,
    });
  }

  return resolveSiteConfigFromEnv(input.env);
}
